import { Card, Col, Row, Typography } from "antd";
import React from "react";
import Stats, { IStatsProps } from "../Stats/Stats";
import "./Section.scss";

const { Title, Text } = Typography;

function Section({
  name,
  subName,
  description,
  icon,
  stats,
}: {
  name: string;
  subName?: string;
  description: string;
  icon: React.ReactNode;
  stats: IStatsProps[];
}) {
  return (
    <Row
      align={"top"}
      justify={"start"}
      gutter={[10, 10]}
      style={{ textAlign: "left" }}
      className="Section"
      wrap={false}
    >
      <Col
        flex="75px"
        className="icon"
      >
        {icon}
      </Col>
      <Col flex="auto">
        <Card style={{ backgroundColor: "#fff", borderRadius: "16px" }}>
          <Row
            align={"middle"}
            justify={"space-between"}
            gutter={[24, 24]}
          >
            <Col span={24}>
              <Row
                gutter={[24, 24]}
                align={"middle"}
                justify={"space-between"}
                style={{ marginBottom: 24 }}
              >
                <Col>
                  <Title
                    level={4}
                    style={{ margin: 0, display: "flex", alignItems: "center", gap: "5px" }}
                  >
                    {name}
                    {subName && (
                      <Text>
                        - <Text style={{ fontSize: 20, fontWeight: 400 }}>{subName}</Text>
                      </Text>
                    )}{" "}
                  </Title>
                  <Text className="gray-7">{description}</Text>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={[24, 24]}>
            {stats.map((stat) => (
              <Col
                span="12"
                key={stat.name}
              >
                <Stats {...stat} />
              </Col>
            ))}
          </Row>
        </Card>
      </Col>
    </Row>
  );
}

export default Section;
